import React, { useEffect } from 'react';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  maxWidth?: string;
}

export function Modal({ isOpen, onClose, title, children, maxWidth = '600px' }: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl p-6 shadow-lg border border-[--clinqr-border] relative animate-in fade-in zoom-in duration-200"
        style={{ maxWidth, width: '100%' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-lg hover:bg-[--clinqr-bg-subtle] transition-colors"
          aria-label="Close modal"
        >
          <X className="w-5 h-5 text-[--clinqr-text-secondary]" strokeWidth={2} />
        </button>

        {title && (
          <h2 className="text-[--clinqr-text-primary] mb-4 pr-8 text-xl font-semibold">
            {title}
          </h2>
        )}

        <div className="text-[--clinqr-text-primary]">
          {children}
        </div>
      </div>
    </div>
  );
}
